/** @format */

import agencyImage from "../../assets/images/agency/1.webp";
import agencyImage2 from "../../assets/images/agency/2.webp";
import agencyImage3 from "../../assets/images/agency/3.webp";
import agencyImage4 from "../../assets/images/agency/4a.webp";
import agencyImage5 from "../../assets/images/agency/5a.webp";

// import mybikeImage1 from "../../assets/images/myBike/1.webp";
// import mybikeImage2 from "../../assets/images/myBike/2.webp";
// import mybikeImage3 from "../../assets/images/myBike/3.webp";
// import mybikeImage4 from "../../assets/images/myBike/4.webp";
// import mybikeImageMain from "../../assets/images/myBike/main.webp";

import radarMain from "../../assets/images/Radar/main.webp";
import radarImage1 from "../../assets/images/Radar/1.webp";
import radarImage2 from "../../assets/images/Radar/2.webp";
import radarImage3 from "../../assets/images/Radar/3.webp";
import radarImage4 from "../../assets/images/Radar/4.webp";

import ardenImage1 from "../../assets/images/arden/m4.webp";
import ardenImage2 from "../../assets/images/arden/n2.webp";
import ardenImage3 from "../../assets/images/arden/n3.webp";
import ardenImage4 from "../../assets/images/arden/n4.webp";
import ardenImage5 from "../../assets/images/arden/n5.webp";
import ardenImage6 from "../../assets/images/arden/n6.webp";

import physioflowImage1 from "../../assets/images/physioflow/1a.webp";
import physioflowImage2 from "../../assets/images/physioflow/2a.webp"
import physioflowImage3 from "../../assets/images/physioflow/3a.webp";
import physioflowImage4 from "../../assets/images/physioflow/4a.webp";



export const projects = [
  {
    image1: ardenImage1,
    name: "Headless E-commerce Storefront",
    // year: "2026",
    isLarge: true,
    images: [ardenImage1, ardenImage2, ardenImage3, ardenImage4, ardenImage5, ardenImage6],
    video: null,
    techsteck: "Next.js, Shopify Storefront API, GraphQL, CSS Modules, Framer Motion",
    description:
      "A custom headless Shopify storefront for a furniture brand, built with Next.js and Shopify Storefront API. The project focuses on clean catalog structure, product pages, cart interaction, and a polished responsive shopping experience across desktop and mobile.",
    liveLink: "https://arden-furniture.vercel.app",
    codeLink: "https://github.com/NKoshmak/arden",
  },

  // {
  //   image1: mybikeImageMain,
  //   name: "Product Landing Page",
  //   year: "2025",
  //   isLarge: false,
  //   images: [mybikeImage1, mybikeImage2, mybikeImage3, mybikeImage4],
  //   video: null,
  //   techsteck: "HTML5, CSS3, BEM, JavaScript, GSAP",
  //   description:
  //     "A fully responsive product landing page focused on clean layout, strong visuals, and clear content structure. The project features hover interactions, subtle scroll-based animations, and a fully responsive layout designed to work seamlessly across screen sizes.",
  //   liveLink: "https://mybikelanding.netlify.app",
  //   codeLink: "https://github.com/NKoshmak/landing_mybike",
  // },



  // {
  //   image1: maskImage1,
  //   name: "Headless E-commerce Storefront",
  //   year: "2026",
  //   isLarge: false,
  //   images: [maskImage1, maskImage2, maskImage3],
  //   video: null,
  //   techsteck: "Next.js, Shopify Storefront API, GraphQL, CSS Modules, Framer Motion",
  //   description:
  //     "A custom headless Shopify storefront for a beauty brand, built with Next.js and Shopify Storefront API. The project focuses on clean catalog structure, product pages, cart interaction, and a polished responsive shopping experience across desktop and mobile.",
  //   liveLink: "https://ela-beauty.vercel.app",
  //   codeLink: null,
  // },

  {
    image1: radarMain,
    name: "SaaS Product Website",
    // year: "2026",
    isLarge: false,
    images: [radarMain, radarImage1, radarImage2, radarImage3, radarImage4],
    video: null,
    techsteck: "HTML5, CSS3, JavaScript",
    description:
      "A fully responsive SaaS landing page focused on product clarity, structured content hierarchy, and conversion-driven layout. The project includes reusable UI components, pricing logic, hover interactions, optimized for seamless performance across all screen sizes.",
    liveLink: "https://radarlanding.netlify.app",
    codeLink: "https://github.com/NKoshmak/rival_radar",
  },
  {
    image1: physioflowImage1,
    name: "CMS Practitioner Landing",
    // year: "2026",
    isLarge: false,
    images: [physioflowImage1, physioflowImage2, physioflowImage3, physioflowImage4],
    video: null,
    techsteck: "Next.js, Sanity CMS, HubSpot Forms API, Framer Motion, Tailwind CSS",
    description:
      "A dark editorial one-page website for an independent movement therapy practitioner. Built with Next.js and Sanity CMS, the project includes editable content sections, subtle scroll-based interactions, smooth scrolling, responsive layouts, and a custom booking form integrated with HubSpot Forms API.",
    liveLink: "https://physioflow-practitioner.vercel.app",
    codeLink: "https://github.com/NKoshmak/physioflow",
  },

  {
    image1: agencyImage,
    name: "Creative Agency Landing",
    // year: "2026",
    isLarge: true,
    images: [agencyImage,agencyImage2, agencyImage3, agencyImage4, agencyImage5],
    video: null,
    techsteck: "Next.js, Tailwind CSS, Framer Motion",
    description:
      "Creative agency landing page developed with Next.js and Tailwind CSS, designed to showcase brand positioning through bold typography and structured layouts. Features interactive services section, smooth scrolling experience, and fully responsive design optimized for modern web standards.",
    liveLink: "https://babepaisley.vercel.app",
    codeLink: "https://github.com/NKoshmak/agency-landing-nextjs",
  },


  //    {
  //   image1: airImageMain,
  //   name: "Air",
  //   year: "2023",
  //   isLarge: true,
  //   images: [airImage1, airImage2, airImage3, airImage4, airImage5, airImage6],
  //   video: null,
  //   techsteck: "HTML5, CSS3, SASS, BEM",
  //   description:
  //     "A fully responsive landing page, that ensuring seamless functionality across all screen sizes. Provide smooth navigation with links scrolling to corresponding sections, reusable components for consistency in “Who We Are” and “Our Expertise” sections, interactive slider and animated cards for an engaging user experience, functional contact forms with validation and smooth scrolling after submission.",
  //   liveLink: "https://nkoshmak.github.io/air-landing/",
  //   codeLink: "https://github.com/NKoshmak/air-landing",
  // },
];
